import '../assets/css/colors.css'
import '../assets/css/Principais.css'
import '../assets/css/fonts.css'
import '../assets/css/homePage.css'
import { useEffect, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { BuscaFotoFashion, consultaVendedoraProxima } from './funcionalidades/bancoGet'

import Celular from '../assets/imgs/phone.png'
import RevendFotoPadrao from '../assets/imgs/menuLogo.png'

var windowHeight = window.screen.availHeight;

function capitalizeEachWord(string) {
    if (typeof string !== 'string' || string.length === 0) {
      return '';
    }
    return string.split(' ').map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
}

const VendedoraProximaCard = ({item,navigate}) =>{

    const [userImage, setUserImage] = useState('')

    useEffect(()=>{
        if(item && item[8]){
            BuscaFotoFashion({IMG: item[8]})
                .then(resp => {
                    if(resp?.Error){
                        BuscaFotoFashion({IMG: item[8]})
                            .then(resp2 => {
                                if(!resp2?.Error){
                                    setUserImage(resp2)
                                }
                            })
                    }else{
                        setUserImage(resp)
                    }
                })
        }
    },[])

    return item ? <div className='vendedoraCard'>
    
        <div className="topRevend">
            <div className="revendFoto" style={userImage ? {
                        backgroundImage: `url('${'data:image/png;base64,'+userImage}')`, 
                        borderRadius: '5px',
                        border: '2px solid #FFFFFF',
                        backgroundPosition: 'center'} : {backgroundImage: `url('${RevendFotoPadrao}')`}}></div>
            <div className='textInfoRevend'>{capitalizeEachWord(item[0].split(" ").slice(0,4).join(" "))}</div>

            {item[3] ? 
                <a 
                    className='wpRevend' 
                    href={`https://wa.me/55${item[3].replace(/\s+/g, "")}?text=Ol%C3%A1+${capitalizeEachWord(item[0].trim().split(' ')[0])}%21+Encontrei+seu+contato+no+localizador+de+revendedores+e+fiquei+interessado+nos+produtos+da+Babita%21+Gostaria+de+saber+mais+e+fazer+uma+compra.+Poderia+me+ajudar%3F`}
                >
                    <div className='wpImage'></div>
                </a> 
            : <></>}
        </div>

    </div> : <></>
}

export default function HomePage(props){

    const [logoAnimation, setLogoAnimation] = useState(false)
    const [cep, setCep] = useState('')
    const [vendedorasProximasList, setVendedorasProximasList] = useState(null)
    const [busca, setBusca] = useState(false)
    const [proximaVend, setProximaVend] = useState(0)
    const [verVendedoras,setVerVendedoras] = useState(false)
    const navigate = useNavigate();

    const [visiveis, setVisiveis] = useState([]);

    const [ativaResp, setAtivaResp] = useState(null)

    useEffect(()=>{
        if (ativaResp == null){
            if (window.matchMedia("(max-width: 767px)").matches){
              setAtivaResp(true)
            }else{
                setAtivaResp(false)
            }
        }
    },[ativaResp])

    useEffect(() => {
        setLogoAnimation(true)
    }, []);

    // 🔥 PAGINAÇÃO CORRIGIDA (3 EM 3 SEM BUG)
    useEffect(() => {
        if (Array.isArray(vendedorasProximasList) && vendedorasProximasList.length > 0) {

            const total = vendedorasProximasList.length

            let inicio = proximaVend * 3

            if (inicio >= total) {
                inicio = 0
                setProximaVend(0)
            }

            let fim = inicio + 3

            let novaLista = vendedorasProximasList.slice(inicio, fim)

            // completa com início se faltar
            if (novaLista.length < 3 && total > 3) {
                const restante = 3 - novaLista.length
                novaLista = [
                    ...novaLista,
                    ...vendedorasProximasList.slice(0, restante)
                ]
            }

            setVisiveis(novaLista)

        } else {
            setVisiveis([])
        }
    }, [proximaVend, vendedorasProximasList])

    // 🔍 BUSCA PROTEGIDA
    useEffect(()=>{
        if(cep !== '' && cep.length === 8){
            consultaVendedoraProxima({CEP: cep})
                .then(resp => {
                    if(resp?.NotFound){
                        setVendedorasProximasList([])
                    }else{
                        const lista = Array.isArray(resp) ? resp : []
                        setVendedorasProximasList(lista)
                        setVerVendedoras(true)
                        setProximaVend(0)
                    }
                })
                .catch(()=>{
                    setVendedorasProximasList([])
                })
        }
    },[cep, busca])

    return <>
        <div className="containerPrincipal homePage" style={{minHeight: "100vh", display: 'flex',
    flexDirection: 'column', overflowY: "hidden", backgroundColor: ativaResp ? 'var(--escuro-cinza-color)' : '#706c6d'}}>

        <div className="celular" style={ativaResp ? {} : {backgroundImage: `url(${Celular})`}}>

            <div className={`homelogo ${logoAnimation ? 'logoAnima' : ''}`}></div>

           {!verVendedoras ? <>
           
            <div className='introText'>Tenha uma experiência de compra excepcional com a ajuda dos nossos revendedores.</div>
             <div className='introText'>Digite o seu cep e encontre os revendedores mais próximos!</div>

             <input type='text' className="inputFiltro" onChange={(e)=>setCep(e.target.value)}/>

             <div className="btnBuscar" onClick={()=>setBusca(!busca)}>Buscar</div>
             <div className="divisor"></div>

             {vendedorasProximasList ? vendedorasProximasList.length === 0 ? <div className='introText'>Nenhum Revendedor por perto, tente outro CEP.</div> : <></> : <></>}
           </> : 

            <div className='vendList'>
                {vendedorasProximasList ? 
                    <>
                    {vendedorasProximasList.length === 1 ?
                    <VendedoraProximaCard item={vendedorasProximasList[0]} navigate={val => navigate(val)}/>
                    : vendedorasProximasList.length === 2 ?
                    <>
                    <VendedoraProximaCard item={vendedorasProximasList[0]} navigate={val => navigate(val)}/>
                    <VendedoraProximaCard item={vendedorasProximasList[1]} navigate={val => navigate(val)}/>
                    </> : <>
                    {visiveis.map((item, idx) => (
                        <VendedoraProximaCard key={idx} item={item} navigate={val => navigate(val)} />
                    ))}
                    </>}
                    
                    { vendedorasProximasList.length > 3 ? 
                        <div className="proxVend" onClick={()=> setProximaVend(prev => prev + 1)}>
                            Próximo Revendedor
                        </div> 
                    : <></>}

                    <div className="btnBuscar btnBuscarCep" onClick={()=>setVerVendedoras(false)}>Buscar outro CEP</div>

                    </> : <></>}

            </div>}

        </div>
        </div>
    </>
}